import interceptorAxios from './InterceptorAxios';

const ServicioLineaExpres = {
   
    paginacion_admin(objeto){
        return interceptorAxios.post('/linea/paginacion_admin.json',objeto);
    }
    

}

export default ServicioLineaExpres;